export const SUPPORT_LINKS = [
    {
        identifier: "terms-and-conditions",
        url: "/terms-and-conditions",
        label: "Terms & Conditions",
    },
    {
        identifier: "privacy-policy",
        url: "/privacy-policy",
        label: "Privacy Policy",
    },
    {
        identifier: "return-policy",
        url: "/return-policy",
        label: "Return Policy",
    },
];
